export const HTML_EVENTS_API_ROUTE = '/html-event-tracks';

export const CLICK = '/html-element-clicked-tracks';
export const PAGE_LOADED = '/page-loaded-tracks';
export const COMPONENT_DISPLAYED = '/component-displayed-tracks';
